import { BiomarkerPageCriteria } from '../model/biomarker-page-criteria';
import { SignalPageCriteria } from '../model/signal-page-criteria';

export namespace BiomarkerActions {
  const prefix = '[Biomarkers]';

  export class GetPage {
    static readonly type = `${prefix} Get page`;

    constructor(readonly criteria: BiomarkerPageCriteria) {}
  }

  export class GetSignalsPage {
    static readonly type = `${prefix} Get signals page`;

    constructor(readonly criteria: SignalPageCriteria) {}
  }
}
